// 3rd party
import * as React from 'react';

// Shared UI
// import { LocalizedText } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';
import { useLocalization, LocalizedText } from '@shared-ui/localization-context';

interface WidgetPreviewProps {
  children: React.ReactNode;
}

const WidgetPreview = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function WidgetPreview(props: WidgetPreviewProps): JSX.Element {
    const l10n = useLocalization();
    const { children } = props;

    return (
      <section>
        <UitkHeading tag="h2" size={4}>
          <LocalizedText message="product.widget.preview.title" />
        </UitkHeading>

        <UitkParagraph size={1}>
          <LocalizedText message="product.widget.preview.content.this_is_how_widget_will_display" />
        </UitkParagraph>

        {/* #widget-container */}
        <UitkSpacing margin={{ blockstart: 'four' }}>
          <div>
            {/* Add product-specific WidgetPreviewFrame component/s */}
            {children}
          </div>
        </UitkSpacing>
      </section>
    );
  },
);

export { WidgetPreview };
